var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJamf = function SvgJamf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jamf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#778EB1",
    fillRule: "evenodd",
    d: "M19 3.3c.6 0 1 .4 1 1v14.2c0 .6-.5 1-1 1H1c-.6 0-1-.4-1-.9v-2.8c0-.6.5-1 1-1h4.4c1.9 0 3-.7 3.6-2.5l1.8-5.5c.7-2.3 2.2-3.4 4.8-3.4zM1.1 0h8.5c.7 0 1.2.6 1.1 1.3-.4 1.8-1 4.9-1 4.9-.6 3.1-3.1 3.4-4.8 3.4H1.1C.5 9.6 0 9.1 0 8.5V1.1C0 .5.5 0 1.1 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jamf_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgJamf;